import React, { useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as FiIcons from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';
import './Navbar.css';
import { IconContext } from 'react-icons';
import Cookies from 'universal-cookie';
/*import { isRunningInWSL } from 'firebase-tools/lib/utils';*/
import { useNavigate } from "react-router-dom";
import { auth, logout } from "../firebase";

const cookies = new Cookies();

function Navbar(props) {
  /* con el nuevo Login*/
  const [user, loading, error] = useState(auth);
  const navigate = useNavigate();

  const validarSesion = () => {
    if (!user) navigate("/");
  }

  /* con el nuevo Login*/
  const [sidebar, setSidebar] = useState(false);
  
  const showSidebar = () => setSidebar(!sidebar);
  
  return (
    <>
      <IconContext.Provider value={{ color: '#000' }}>
        <div className='navbar'>
          <Link to='#' className='menu-bars'>
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
          <ul className='itemsRight d-flex'>
            {/*<li className='nav-text' >
              <Link to='/ayuda'>
                <FiIcons.FiHelpCircle style={{alignItems:'end', color:'#66C3C5',width:'2em',height:'2em'}}/>
                
              </Link>
            </li>
            <li className='nav-text' >
              <Link to='/ayuda'>
                <AiIcons.AiFillBell style={{color:'#66C3C5',width:'2em',height:'2em'}}/>
                
              </Link>
            </li>*/}
            <li className='nav-text' >
              <img alt='Fibtex' className='logo' src="/logo-fibtex.svg"/>
            </li>
            
          </ul>
        </div>
        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'} >
          <ul style={{ paddingLeft:'1rem'}} className='nav-menu-items' onClick={showSidebar} >
            <li className='navbar-toggle'>
              <Link to='#' className='menu-bars'>
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {SidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName} onClick={ validarSesion } >
                  <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
            <li className='nav-text' onClick={ logout }>
              <Link to='/'><FaIcons.FaSignOutAlt/>
                <span>Salir</span>
              </Link>
            </li>
          </ul>
          
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
